import { render, staticRenderFns } from "./InsumosForm.vue?vue&type=template&id=de4b87d6"
import script from "./InsumosForm.vue?vue&type=script&lang=js"
export * from "./InsumosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports